export default __webpack_public_path__ + "static/PM2-1ea8123c6c91fcc5011315ddda08afc7.jpg";